import { useMutation } from '@tanstack/react-query';
import type { CandidateBoardsMovePostRequest } from '../types/CandidateBoard';

export default function usePostCandidateBoardsMove() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidate_profile_id,
      target_board_id,
      order_number,
    }: CandidateBoardsMovePostRequest) => {
      const response = await fetch(`/agent/api/candidate_boards/move_candidate_profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          candidate_profile_id,
          target_board_id,
          order_number,
        }),
      });
      const data = await response.json();
      return data;
    },
  });
}
